import { roles } from "../../helper";

/**
 * New Tickets (all tabs): super_user sees "Event Info" on the event column;
 * all other roles keep "EVENT NAME".
 */
export function newTicketsEventHeaderLabelForSuperUser(
  userRole: string | undefined
): string {
  if (userRole === roles.SUPER_USER) {
    return "Event Info";
  }
  return "EVENT NAME";
}
